window.PG_ORDER_CONSTRAINTS = Object.freeze({
  "11531": { minimumOrder: 250, multiple: 0 },
  "11594": { minimumOrder: 0, multiple: 100 },
  "11595": { minimumOrder: 0, multiple: 100 },
  "12483": { minimumOrder: 0, multiple: 50 },
  "12536": { minimumOrder: 0, multiple: 50 },
  "12549": { minimumOrder: 0, multiple: 24 },
  "12552": { minimumOrder: 0, multiple: 50 },
  "12553": { minimumOrder: 0, multiple: 50 },
  "12766": { minimumOrder: 0, multiple: 25 },
  "12767": { minimumOrder: 0, multiple: 25 },
  "12773": { minimumOrder: 0, multiple: 20 },
  "13574": { minimumOrder: 250, multiple: 0 },
  "13575": { minimumOrder: 250, multiple: 0 },
  "14190": { minimumOrder: 250, multiple: 0 },
  "14600": { minimumOrder: 250, multiple: 0 },
  "14845": { minimumOrder: 0, multiple: 50 },
  "14930": { minimumOrder: 250, multiple: 0 },
  "15412": { minimumOrder: 0, multiple: 50 },
  "15447": { minimumOrder: 0, multiple: 150 },
  "15504": { minimumOrder: 250, multiple: 0 },
  "15708": { minimumOrder: 0, multiple: 100 },
  "15709": { minimumOrder: 0, multiple: 50 },
  "16103": { minimumOrder: 250, multiple: 0 },
  "18085": { minimumOrder: 250, multiple: 0 },
  "18086": { minimumOrder: 250, multiple: 0 },
  "18088": { minimumOrder: 250, multiple: 0 },
  "18100": { minimumOrder: 0, multiple: 100 },
  "19124": { minimumOrder: 0, multiple: 100 },
  "19173": { minimumOrder: 0, multiple: 100 },
  "19195": { minimumOrder: 250, multiple: 0 },
  "19943": { minimumOrder: 0, multiple: 50 },
  "20413": { minimumOrder: 0, multiple: 50 },
  "20414": { minimumOrder: 0, multiple: 50 },
  "20822": { minimumOrder: 250, multiple: 0 },
  "20823": { minimumOrder: 250, multiple: 0 },
  "20824": { minimumOrder: 250, multiple: 0 },
  "21442": { minimumOrder: 250, multiple: 0 },
  "21443": { minimumOrder: 250, multiple: 0 },
  "21807": { minimumOrder: 250, multiple: 0 },
  "21918": { minimumOrder: 250, multiple: 0 }
});

window.dispatchEvent(new Event('pg:order-constraints:ready'));